import React, { useState, useEffect } from "react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

const CajaCategoriaForm = ({ categoria, onClose, onSave }) => {
  const [formData, setFormData] = useState({ detalle: "", tipo: "INGRESO", activo: true });

  useEffect(() => {
    if (categoria) {
      setFormData({
        detalle: categoria.detalle,
        tipo: categoria.tipo,
        activo: categoria.activo,
      });
    }
  }, [categoria]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md max-h-[90vh] overflow-y-auto">
        <Card className="border-none shadow-none">
          <CardContent className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                {categoria ? "Editar categoría" : "Nueva categoría"}
              </h2>
              <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-xl leading-none">
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <label className="block text-sm font-medium">Nombre *</label>
                <input
                  type="text"
                  name="detalle"
                  value={formData.detalle}
                  onChange={handleChange}
                  placeholder="Ej: Compra insumos"
                  className="w-full border rounded-lg p-2"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium">Tipo *</label>
                <select
                  name="tipo"
                  value={formData.tipo}
                  onChange={handleChange}
                  disabled={!!categoria}
                  className="w-full border rounded-lg p-2 disabled:bg-gray-100 disabled:text-gray-500"
                >
                  <option value="INGRESO">Ingreso</option>
                  <option value="EGRESO">Egreso</option>
                </select>
              </div>
              {categoria && (
                <label className="flex items-center gap-2 text-sm">
                  <input
                    type="checkbox"
                    name="activo"
                    checked={formData.activo}
                    onChange={handleChange}
                    className="w-4 h-4 rounded accent-brand-600"
                  />
                  Activa
                </label>
              )}
              <div className="flex justify-end space-x-2 pt-4">
                <Button variant="outline" onClick={onClose} type="button">Cancelar</Button>
                <Button type="submit">{categoria ? "Actualizar" : "Crear"}</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CajaCategoriaForm;
